import { Flex, Text, Table, TableHeader, TableBody, TableRow, TableCell } from "@jsq/ds/core";
import { Icon } from "@jsq/ds/icons";
import { Colors } from "@jsq/ds/styles";
import { SPACING } from "~/styles/variables";
import { deleteIconCell, deleteIcon } from "./styles_vanilla.css";
import type { ChangeInspectionModalProps } from "./types";

type EntityModeContentProps = {
  changes: NonNullable<Extract<ChangeInspectionModalProps, { mode: "entity" }>["changes"]>;
  readOnly: boolean;
  onDeleteChange?: (index: number) => void;
};

export const EntityModeContent = ({
  changes,
  readOnly,
  onDeleteChange,
}: EntityModeContentProps) => (
  <Table variant="muted" hasBottomBorder>
    <TableHeader>
      <TableRow>
        <TableCell header />
        <TableCell header>
          <Text variant="secondary-md" color={Colors.Neutral600}>
            Current
          </Text>
        </TableCell>
        <TableCell header>
          <Text variant="secondary-md" color={Colors.Neutral600}>
            Proposed
          </Text>
        </TableCell>
        {!readOnly && <TableCell header />}
      </TableRow>
    </TableHeader>
    <TableBody>
      {changes.map((change, index) => (
        <TableRow key={`${change.billingGroupName}-${index}`}>
          <TableCell>
            <Text variant="regular-md">{change.detail.label}</Text>
          </TableCell>
          <TableCell>
            <Flex flexDirection="column" gap={SPACING.X_SMALL}>
              {change.detail.currentValues.map((val, valIndex) => (
                <Text key={`current-${valIndex}`} variant="regular-md">
                  {val}
                </Text>
              ))}
            </Flex>
          </TableCell>
          <TableCell>
            <Flex flexDirection="column" gap={SPACING.X_SMALL}>
              {change.detail.proposedValues.map((val, valIndex) => (
                <Text key={`proposed-${valIndex}`} variant="regular-md">
                  {val}
                </Text>
              ))}
            </Flex>
          </TableCell>
          {!readOnly && (
            <TableCell className={deleteIconCell}>
              <Icon
                type="trash"
                variant="outline"
                size="medium"
                color={Colors.Neutral500}
                className={deleteIcon}
                aria-label={`Delete proposed change ${index + 1}`}
                onClick={() => onDeleteChange?.(index)}
              />
            </TableCell>
          )}
        </TableRow>
      ))}
    </TableBody>
  </Table>
);
